import React from "react";
import { useParams } from "react-router";

import styles from "./ProductPage.module.scss";

import Layout from "../../components/Layout/Layout";
import ImageSlider from "../../components/pages/Product/ImageSlider/ImageSlider";
import ProductInfo from "../../components/pages/Product/ProductInfo/ProductInfo";
import ProductDescription from "../../components/pages/Product/ProductDescription/ProductDescription";
import Feedback from "../../components/general/Feedback/Feedback";
import GeneralSlider from "../../components/general/GeneralSlider/GeneralSlider";
import { IProduct } from "../../models/IProduct";
import { productService } from "../../services/product.service";

const goodsArr = [
  { id: 0, img: "/img/main/temp/1.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 1, img: "/img/main/temp/2.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 2, img: "/img/main/temp/3.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 3, img: "/img/main/temp/4.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 4, img: "/img/main/temp/1.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
];

const ProductPage: React.FC = () => {
  const { id } = useParams();
  const productId = id ? Number(id) : null;
  const articleSlug = id && Number.isNaN(Number(id)) ? id.toUpperCase() : null;
  const [product, setProduct] = React.useState<IProduct | null>(null);
  const [allProducts, setAllProducts] = React.useState<IProduct[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [loadError, setLoadError] = React.useState<string | null>(null);

  React.useEffect(() => {
    let isMounted = true;

    const loadProduct = async () => {
      try {
        setIsLoading(true);
        setLoadError(null);

        const productsPromise = productService.getProducts();

        let data: IProduct | null = null;
        if (articleSlug) {
          try {
            data = await productService.getProductByArticle(articleSlug);
          } catch {
            data = null;
          }
        } else if (productId !== null && !Number.isNaN(productId)) {
          try {
            data = await productService.getProductById(productId);
          } catch {
            data = null;
          }
        }

        let products: IProduct[] = [];
        try {
          products = await productsPromise;
        } catch {
          products = [];
        }
        if (isMounted) {
          setAllProducts(products);
        }

        if (!data) {
          data = products.length > 0 ? products[0] : null;
        }

        if (isMounted) {
          setProduct(data);
        }
      } catch (error) {
        if (isMounted) {
          setProduct(null);
          setLoadError("Не удалось загрузить товары. Проверьте API /api/v1/products.");
        }
        console.error("Не удалось загрузить товар:", error);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    loadProduct();
    return () => {
      isMounted = false;
    };
  }, [productId, articleSlug]);

  return (
    <Layout>
      <section>
        <div className="container">
          {isLoading && <p>Загрузка товара...</p>}
          {!isLoading && !product && <p>{loadError || "Товар не найден."}</p>}
          {product && (
          <div className={styles.body}>
            <div className={styles.imageSlider}>
              <ImageSlider product={product} />
            </div>
            <div className={styles.productInfo}>
              <ProductInfo product={product} allProducts={allProducts} />
            </div>
          </div>
          )}
          <div className={styles.productDescription}>
            <ProductDescription product={product} />
          </div>
        </div>
      </section>
      <GeneralSlider title="С этим товаром покупают" subtitle="Посмотреть все товары" slides={goodsArr} />
      <GeneralSlider title="Фурнитура к выбранной  ткани" subtitle="Посмотреть все товары" slides={goodsArr} />
      <Feedback />
    </Layout>
  );
};

export default ProductPage;
